import { Container } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { FormChoice } from '../../../../form-choice/form-choice';
import {
    blockIcons,
    defaultToolbar,
    isValidJSON,
    unselectableProperties,
} from '../utils/helpers';
import { makeFormEditorComponents } from './FormEditor/formEditorComponentsView';

const attributes_key = 'data-widget';

const getAttributes = (component) => {
    const attributes = component.getAttributes()[attributes_key];
    return isValidJSON(attributes) ? JSON.parse(attributes) : {};
};

const setAttributes = (component, data) => {
    component.setAttributes({ [attributes_key]: JSON.stringify(data) });
    component.em.trigger('component:update', component);
};

const editComponentCommand = (editor, config) => {
    const selectedComponent = editor.getSelected();
    const attr = getAttributes(selectedComponent) || config.attributes;
    return Container.instance
        .get(DialogService)
        .open({
            viewModel: FormChoice,
            model: {
                formId: config.formId,
                title: config.title + ' bearbeiten',
                data: attr || {},
                contextModelId: undefined,
            },
        })
        .whenClosed(async (data) => {
            const output = data.output;
            if (output) {
                setAttributes(selectedComponent, output);
                selectedComponent.components(
                    makeFormEditorComponents(output, config)
                );
            }
        });
};


import { blockCategories } from '../../categories';

export default (editor, config) => {

    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add(config.id, {
        label: config.title,
        category: blockCategories.custom,
        content: {
            type: config.id,
            classes: [
                'sio-form',
                'bg-slate-100',
                'p-4',
                'rounded-md',
                'w-fit',
                'mt-6',
                'mb-6',
            ],
        },
        media: `
            ${
                blockIcons[config.icon]
                    ? blockIcons[config.icon]
                    : config.icon
                    ? `<div style="font-size:40px;width:40px" class="dashicon dashicons dashicons-${config.icon}"></div>`
                    : `<svg
                        viewBox="0 0 24 24"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <path d="M 6 2 C 4.9045455 2 4 2.9045455 4 4 L 4 20 C 4 21.095455 4.9045455 22 6 22 L 18 22 C 19.095455 22 20 21.095455 20 20 L 20 4 C 20 2.9069372 19.093063 2 18 2 L 6 2 z M 6 4 L 18 4 L 18 20 L 6 20 L 6 4 z M 8 6 L 8 9 L 16 9 L 16 6 L 8 6 z M 8 12 L 8 14 L 10 14 L 10 12 L 8 12 z M 12 12 L 12 14 L 16 14 L 16 12 L 12 12 z M 8 16 L 8 18 L 10 18 L 10 16 L 8 16 z M 12 16 L 12 18 L 16 18 L 16 16 L 12 16 z"></path>
                    </svg>`
            }
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultView = defaultType.view;

    domComponents.addType(config.id, {
        model: {
            defaults: {
                'custom-name': 'From Editor',
                components: [
                    {
                        tag: 'div',
                        components: [...makeFormEditorComponents()],
                        ...unselectableProperties,
                    },
                ],
                traits: [
                    {
                        type: 'checkbox',
                        name: 'inSlider',
                        label: 'In Slider',
                    },
                ],
                toolbar: [
                    ...defaultToolbar,
                    {
                        attributes: { class: 'fa fa-pencil-alt' },
                        label:
                            '',
                        command: (editor) =>
                            editComponentCommand(editor, config),
                    },
                ],
            },
        },

        isComponent(el) {
            if (el && el.classList && el.classList.contains(config.id)) {
                return { type: config.id };
            }
        },
        view: defaultView,
    });
};
